import { isAuthRedirect, isMsalRedirectAuthenticator } from '@ms/yammer-web-authenticators';
import { setupAuthenticator } from 'bootstrap/auth';
import { setupTelemetry } from 'bootstrap/config';
import loadPolyfills from 'bootstrap/entries/2-polyfill';
import 'bootstrap/publicPath';

import authBootstrap from './auth';

(async () => {
  await loadPolyfills();
  await setupTelemetry({ skipNextCleanup: true });
  const authenticator = await setupAuthenticator();

  if (isMsalRedirectAuthenticator(authenticator)) {
    await authenticator.initializeCurrentAccount();

    if (isAuthRedirect()) {
      return;
    }
  }

  await authBootstrap();
})();
